/*
 * @Autor: GeekMzy
 * @Date: 2022-05-27 15:50:56
 * @LastEditors: GeekMzy
 * @LastEditTime: 2022-05-27 15:51:58
 * @FilePath: \htwlgs-drainage-webv2.2\src\router\index.ts
 * @Author: desktop-1llkr2o
 */
import { createPinia } from 'pinia'
const pinia = createPinia()
export default pinia
